import { waffleIconMap } from '../../shared/menu-icon-map'

export function createMenuIconMap() {
  const iconMap = new Map()

  for (const key in waffleIconMap) {
    iconMap.set(key, waffleIconMap[key])
  }

  if (!window.sideMenu?.menusData) {
    return iconMap
  }

  function traverse(menus, inheritedIcon = null) {
    if (!Array.isArray(menus)) return

    for (const menu of menus) {
      const menuId = menu.id || menu.menuId
      if (!menuId) continue

      const currentIcon = menu.icon || inheritedIcon

      if (currentIcon) {
        iconMap.set(menuId, currentIcon)
      }

      if (menu.items) {
        traverse(menu.items, currentIcon)
      }
    }
  }

  traverse(window.sideMenu.menusData)
  return iconMap
}
